import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.EGIFTCARD_EMAIL_SENDING:
            return { loading: true };

        case types.EGIFTCARD_EMAIL_SENDING_COMPLETED:
            return { loading: false };

        case types.EGIFTCARD_EMAIL_SENDING_FAILED:
            return { loading: false, err: action.type };

        default:
            return state;
    }
};
